module.exports = __webpack_public_path__ + "img/ITN-Logo.eae3f56b.jpeg";